{
  "vitalsEntry": {
    "title": "Tanda Vital",
    "subtitle": "Rekod dan semak tanda vital",
    "printLabel": "Cetak Tanda Vital",
    "recordSection": "Rekod Tanda Vital",
    "save": "Rekod Tanda Vital",
    "cancel": "Batal",
    "saving": "Sedang merekod...",
    "recordedSuccess": "Tanda vital berjaya direkod",
    "recordedError": "Gagal merekod tanda vital",
    "invalidEncounter": "ID kunjungan tidak sah.",
    "historyTitle": "Tanda Vital Terkini",
    "loadingHistory": "Memuatkan tanda vital...",
    "loadError": "Gagal memuatkan tanda vital.",
    "emptyHistory": "Tiada tanda vital direkodkan untuk kunjungan ini.",
    "morseTitle": "Skala Risiko Jatuh Morse",
    "bradenTitle": "Skala Risiko Luka Tekanan Braden",
    "riskScalesSaved": "Skor risiko berjaya direkod",
    "riskScalesFailed": "Tanda vital telah disimpan, tetapi skor risiko gagal direkod"
  },
  "vitals": {
    "systolic": "Tekanan Darah Sistolik",
    "diastolic": "Tekanan Darah Diastolik",
    "heartRate": "Kadar Jantung",
    "respiratoryRate": "Kadar Pernafasan",
    "temperature": "Suhu",
    "oxygenSaturation": "Ketepuan Oksigen (SpO2)",
    "oxygenSaturationShort": "SpO2",
    "painScore": "Skor Kesakitan",
    "weight": "Berat",
    "height": "Tinggi",
    "bmi": "BMI",
    "rangeError": "{{field}} mestilah antara {{min}} hingga {{max}}",
    "placeholders": {
      "temperature": "cth. 37.0",
      "heartRate": "cth. 72",
      "respiratoryRate": "cth. 16",
      "oxygenSaturation": "cth. 98",
      "systolic": "cth. 120",
      "diastolic": "cth. 80",
      "weight": "cth. 70.5",
      "height": "cth. 175",
      "painScore": "0-10"
    }
  },
  "vitalsRange": {
    "normal": "Normal",
    "borderline": "Sempadan",
    "abnormal": "Abnormal",
    "critical": "Kritikal"
  },
  "tableHeaders": {
    "dateTime": "Tarikh/Masa",
    "temperature": "Suhu",
    "heartRate": "Nadi",
    "respiratoryRate": "Nafas",
    "bloodPressure": "Tekanan",
    "oxygenSaturation": "SpO2",
    "weight": "Berat",
    "height": "Tinggi",
    "pain": "Sakit"
  },
  "io": {
    "title": "Asupan & Keluaran",
    "addRecord": "Tambah Rekod",
    "addRecordSection": "Tambah Rekod I/O",
    "loading": "Memuatkan rekod I/O...",
    "loadError": "Gagal memuatkan rekod I/O.",
    "empty": "Tiada rekod I/O didokumenkan untuk kunjungan ini.",
    "totals": {
      "intake": "Jumlah Asupan",
      "output": "Jumlah Keluaran",
      "balance": "Imbangan Bersih",
      "totalsRow": "Jumlah",
      "netLabel": "Bersih"
    },
    "negativeWarning": "Imbangan negatif — semak status cecair",
    "columns": {
      "dateTime": "Tarikh/Masa",
      "type": "Jenis",
      "category": "Kategori",
      "amount": "Kuantiti (ml)",
      "notes": "Nota"
    },
    "fields": {
      "type": "Jenis",
      "category": "Kategori",
      "amount": "Kuantiti (ml)",
      "notes": "Nota"
    },
    "type": {
      "intake": "Asupan",
      "output": "Keluaran"
    },
    "categoryPlaceholder": "Pilih kategori...",
    "amountPlaceholder": "0",
    "notesPlaceholder": "Nota pilihan...",
    "save": "Simpan Rekod",
    "cancel": "Batal",
    "missingValueShort": "--",
    "toast": {
      "added": "Rekod I/O ditambah",
      "addFailed": "Gagal menambah rekod I/O",
      "missingFields": "Sila isi medan yang diperlukan"
    }
  },
  "intake": {
    "oral": "Oral",
    "iv": "IV",
    "bloodProducts": "Produk Darah",
    "tpn": "TPN",
    "tubeFeeding": "Pemberian Tiub",
    "other": "Lain-lain"
  },
  "output": {
    "urine": "Air kencing",
    "drain": "Salir",
    "emesis": "Muntah",
    "stool": "Najis",
    "bloodLoss": "Kehilangan Darah",
    "ngSuction": "Sedutan NG",
    "other": "Lain-lain"
  },
  "wound": {
    "title": "Dokumentasi Penjagaan Luka",
    "subtitle": "Kunjungan #{{id}} — Penilaian luka berstruktur",
    "newAssessment": "Penilaian Luka Baharu",
    "dimensionsTitle": "Dimensi (cm)",
    "woundBedTitle": "Dasar Luka (%)",
    "woundBedTotalWarning": "Jumlah: {{total}}% (sepatutnya 100%)",
    "woundBedTotalOk": "Jumlah: 100%",
    "previousTitle": "Penilaian Sebelumnya",
    "empty": "Tiada penilaian luka direkodkan untuk kunjungan ini.",
    "invalidEncounter": "ID kunjungan tidak sah.",
    "save": "Simpan Penilaian",
    "savedSuccess": "Penilaian luka direkodkan",
    "savedError": "Gagal menyimpan penilaian luka",
    "fields": {
      "woundType": "Jenis Luka",
      "location": "Lokasi",
      "stage": "Peringkat",
      "length": "Panjang",
      "width": "Lebar",
      "depth": "Kedalaman",
      "granulation": "Tisu Granulasi",
      "slough": "Tisu Slough",
      "eschar": "Eschar",
      "epithelial": "Tisu Epitelium",
      "drainageType": "Jenis Eksudat",
      "drainageAmount": "Kuantiti Eksudat",
      "surroundingSkin": "Kulit Sekitar",
      "treatment": "Rawatan Diberikan",
      "painScore": "Skor Kesakitan (0-10)",
      "notes": "Nota"
    },
    "placeholders": {
      "length": "cth. 3.5",
      "width": "cth. 2.0",
      "depth": "cth. 0.5",
      "treatment": "Terangkan rawatan luka yang diberikan...",
      "notes": "Pemerhatian tambahan..."
    },
    "history": {
      "dimensionsLabel": "Dimensi",
      "drainageLabel": "Eksudat",
      "painLabel": "Kesakitan",
      "treatmentLabel": "Rawatan"
    },
    "stage": {
      "stage1": "Peringkat 1",
      "stage2": "Peringkat 2",
      "stage3": "Peringkat 3",
      "stage4": "Peringkat 4",
      "unstageable": "Tidak Boleh Diperingkatkan",
      "deepTissue": "Kecederaan Tisu Dalam",
      "na": "N/A"
    },
    "drainageType": {
      "none": "Tiada",
      "serous": "Serosa",
      "sanguineous": "Sanguineus",
      "serosanguineous": "Serosanguineus",
      "purulent": "Purulen"
    },
    "drainageAmount": {
      "none": "Tiada",
      "scant": "Sangat Sedikit",
      "small": "Sedikit",
      "moderate": "Sederhana",
      "large": "Banyak",
      "copious": "Sangat Banyak"
    },
    "woundType": {
      "pressure": "Kecederaan tekanan",
      "surgical": "Pembedahan",
      "diabetic": "Ulser diabetik",
      "venous": "Ulser vena",
      "arterial": "Ulser arteri",
      "traumatic": "Traumatik",
      "skinTear": "Koyakan kulit",
      "other": "Lain-lain"
    },
    "location": {
      "sacrum": "Sakrum",
      "coccyx": "Koksiks",
      "leftHeel": "Tumit kiri",
      "rightHeel": "Tumit kanan",
      "leftTrochanter": "Trokhanter kiri",
      "rightTrochanter": "Trokhanter kanan",
      "abdomen": "Abdomen",
      "leftLeg": "Kaki kiri",
      "rightLeg": "Kaki kanan",
      "back": "Belakang",
      "other": "Lain-lain"
    },
    "surroundingSkin": {
      "intact": "Utuh",
      "erythema": "Eritema",
      "macerated": "Maserasi",
      "indurated": "Indurasi",
      "edematous": "Edema",
      "warm": "Hangat",
      "discolored": "Berubah warna"
    }
  },
  "carePlan": {
    "title": "Pelan Penjagaan",
    "addPlan": "Tambah Pelan Penjagaan",
    "newPlan": "Pelan Penjagaan Baharu",
    "createPlan": "Cipta Pelan",
    "cancel": "Batal",
    "empty": "Tiada pelan penjagaan didokumenkan untuk pesakit ini.",
    "emptyGoals": "Belum ada matlamat ditetapkan.",
    "goals": "Matlamat",
    "addGoal": "Tambah Matlamat",
    "saving": "Menyimpan...",
    "loading": "Memuatkan pelan penjagaan...",
    "loadError": "Gagal memuatkan pelan penjagaan.",
    "fields": {
      "title": "Tajuk",
      "startDate": "Tarikh Mula",
      "targetDate": "Tarikh Sasaran",
      "description": "Penerangan",
      "target": "Sasaran"
    },
    "placeholders": {
      "title": "cth. Pelan Pencegahan Jatuh",
      "description": "Penerangan matlamat",
      "target": "cth. Tiada jatuh dalam 30 hari"
    },
    "history": {
      "startLabel": "Mula",
      "targetLabel": "Sasaran",
      "goalsLabel": "Matlamat"
    },
    "status": {
      "active": "Aktif",
      "completed": "Selesai",
      "cancelled": "Dibatalkan"
    },
    "goalStatus": {
      "inProgress": "Sedang Berjalan",
      "achieved": "Tercapai",
      "notAchieved": "Belum Tercapai"
    },
    "toast": {
      "planCreated": "Pelan penjagaan dicipta",
      "planCreateFailed": "Gagal mencipta pelan penjagaan",
      "goalAdded": "Matlamat ditambah",
      "goalAddFailed": "Gagal menambah matlamat",
      "planValidation": "Tajuk dan tarikh mula diperlukan",
      "goalValidation": "Penerangan dan sasaran diperlukan"
    }
  }
}
